import packageJSON from "./package.json" assert { type: "json" };
import themes from "./src/themes.js";
import icons from "./src/icons.js";
import images from "./src/images.js";

const { version } = packageJSON;
const cdnURL = "https://client-version.cf.emarsys.net";

export { themes, icons, images, version, cdnURL };
export default { themes, icons, images, version, cdnURL };
